// extracted by mini-css-extract-plugin
export default {"container":"container--OZT3G","text":"text--vjd1L","icon":"icon--Fo_q8","back":"back--jQ4L5","show":"show--tO1P6"};